/**
 * ScoreDashboard joins shared event / Match Odds SSE channels. Only apply a
 * frame when it targets this fancy — otherwise sibling market rates/suspend
 * overwrite the open ScoreDashboard (Lab still broadcasts on statusSocket_*).
 *
 * Bulk `sendNewSocket` arrays are filtered separately via preferBetfairId.
 * Event-wide Suspend/Ball still reaches each fancy via that market's own row /
 * sendSingleSocket room — this guard does not block those.
 */
export function fancySocketBelongsToMarket(
  payload: Record<string, unknown> | null | undefined,
  currentBetfairId: string | null | undefined,
): boolean {
  const want = String(currentBetfairId || '').trim()
  if (!want) return false
  if (!payload || typeof payload !== 'object') return false
  const id = String(payload.betfairId ?? payload.marketId ?? '').trim()
  // Frames without an id are Match Odds / unrelated — do not paint onto a fancy.
  if (!id) return false
  return id === want
}
